module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#text",
      toString: function () {
        return this.url;
      }
    }